
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';
import { File } from '@core/objects/file';
@Component({
    selector: 'form-field-fill-files-v1',
    templateUrl: './fill-files-v1.component.html'
})
export class FillFilesV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public uploading: boolean;
    public valid: boolean;
    public files: File[];
    public initialFiles: File[];

    ngOnInit(): void {
        if(this.fieldSubmission.serialized_value){
            this.initialFiles = this.fieldSubmission.serialized_value;
            this.valid = (this.fieldSubmission.serialized_value.length > 0);
        }
        this.emitValidity();
    }

    public remove(file: File) : void {
        this.initialFiles = this.initialFiles.filter((f:File) => f.id !== file.id);
        // this.onFilesChange(this.initialFiles);
        this.updateValue();
        
    }

    onFilesChange(files: File[]) {
        this.files = files; 
        this.updateValue();
    }

    private updateValue() : void {
         // Ensure that files and initialFiles are arrays, default to empty arrays if null or undefined
        const files = this.files ?? [];
        const initialFiles = this.initialFiles ?? [];
        this.valid = (!this.uploading || files.length > 0 || initialFiles.length > 0 || !this.fieldSubmission.field.mandatory);
        const uf = [...files?.map((f:File) => f.id), ...initialFiles?.map((f:File) => f.id) ];
        // console.log(" Field files value map =====> ",uf);
        this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: uf});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }
}   